// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-micro-up';

export const Component = () => <path d='m12.402 9.5 4.597 6H8z' />;

export const viewBox = '0 0 25 25';
